import { render, staticRenderFns } from "./BoardingRate.vue?vue&type=template&id=964bd176&scoped=true&"
import script from "./BoardingRate.vue?vue&type=script&lang=js&"
export * from "./BoardingRate.vue?vue&type=script&lang=js&"
import style0 from "./BoardingRate.vue?vue&type=style&index=0&id=964bd176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964bd176",
  null
  
)

export default component.exports